"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTimestampMiddleware;

var _react = _interopRequireDefault(require("react"));

var _AbsoluteTime = _interopRequireDefault(require("./AbsoluteTime"));

var _Timestamp = _interopRequireDefault(require("./Timestamp"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTimestampMiddleware() {
  return function () {
    return function () {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _args$ = args[0],
            activity = _args$.activity,
            hideTimestamp = _args$.hideTimestamp;

        if (hideTimestamp) {
          // If "hideTimestamp" is set, we will not render the visual timestamp. But continue to render the screen reader only version.
          return /*#__PURE__*/_react.default.createElement(_AbsoluteTime.default, {
            hide: true,
            value: activity.timestamp
          });
        }

        return /*#__PURE__*/_react.default.createElement(_Timestamp.default, {
          activity: activity
        });
      };
    };
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9NaWRkbGV3YXJlL0FjdGl2aXR5U3RhdHVzL2NyZWF0ZVRpbWVzdGFtcE1pZGRsZXdhcmUuanMiXSwibmFtZXMiOlsiY3JlYXRlVGltZXN0YW1wTWlkZGxld2FyZSIsImFyZ3MiLCJhY3Rpdml0eSIsImhpZGVUaW1lc3RhbXAiLCJ0aW1lc3RhbXAiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7OztBQUVlLFNBQVNBLHlCQUFULEdBQXFDO0FBQ2xELFNBQU87QUFBQSxXQUNMO0FBQUEsYUFDQSxZQUFhO0FBQUEsMENBQVRDLElBQVM7QUFBVEEsVUFBQUEsSUFBUztBQUFBOztBQUNYLHFCQUFzQ0EsSUFBdEM7QUFBQSxZQUFTQyxRQUFULFVBQVNBLFFBQVQ7QUFBQSxZQUFtQkMsYUFBbkIsVUFBbUJBLGFBQW5COztBQUVBLFlBQUlBLGFBQUosRUFBbUI7QUFDakI7QUFDQSw4QkFBTyw2QkFBQyxxQkFBRDtBQUFjLFlBQUEsSUFBSSxFQUFFLElBQXBCO0FBQTBCLFlBQUEsS0FBSyxFQUFFRCxRQUFRLENBQUNFO0FBQTFDLFlBQVA7QUFDRDs7QUFFRCw0QkFBTyw2QkFBQyxrQkFBRDtBQUFXLFVBQUEsUUFBUSxFQUFFRjtBQUFyQixVQUFQO0FBQ0QsT0FWRDtBQUFBLEtBREs7QUFBQSxHQUFQO0FBWUQiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBBYnNvbHV0ZVRpbWUgZnJvbSAnLi9BYnNvbHV0ZVRpbWUnO1xuaW1wb3J0IFRpbWVzdGFtcCBmcm9tICcuL1RpbWVzdGFtcCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGNyZWF0ZVRpbWVzdGFtcE1pZGRsZXdhcmUoKSB7XG4gIHJldHVybiAoKSA9PlxuICAgICgpID0+XG4gICAgKC4uLmFyZ3MpID0+IHtcbiAgICAgIGNvbnN0IFt7IGFjdGl2aXR5LCBoaWRlVGltZXN0YW1wIH1dID0gYXJncztcblxuICAgICAgaWYgKGhpZGVUaW1lc3RhbXApIHtcbiAgICAgICAgLy8gSWYgXCJoaWRlVGltZXN0YW1wXCIgaXMgc2V0LCB3ZSB3aWxsIG5vdCByZW5kZXIgdGhlIHZpc3VhbCB0aW1lc3RhbXAuIEJ1dCBjb250aW51ZSB0byByZW5kZXIgdGhlIHNjcmVlbiByZWFkZXIgb25seSB2ZXJzaW9uLlxuICAgICAgICByZXR1cm4gPEFic29sdXRlVGltZSBoaWRlPXt0cnVlfSB2YWx1ZT17YWN0aXZpdHkudGltZXN0YW1wfSAvPjtcbiAgICAgIH1cblxuICAgICAgcmV0dXJuIDxUaW1lc3RhbXAgYWN0aXZpdHk9e2FjdGl2aXR5fSAvPjtcbiAgICB9O1xufVxuIl19